export default __webpack_public_path__ + "static/media/username-password.9ea6fb69.png";